/* eslint-disable */
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import Footer from '../../Components/Footer/Footer.component';
import I18n from '../../Components/I18n/I18n.component';
import Page from '../../Components/Page/Page.component';
import withEntries from '../../Contexts/Entries/WithEntries.context';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import { createLoginPageLink } from '../Login/Login.page.route';
import './Help.page.i18n';
import HelpPagePropTypes from './Help.page.props';
import helpPageStyles from './Help.page.styles';

/**
 * HelpPageComponent
 * @export
 * @class HelpPageComponent
 * @extends {React.Component<HelpPageComponentComposedProps, HelpPageComponentState>}
 */
export class HelpPageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<HelpPageComponentProps>}
   * @memberof HelpPageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`HelpPage`}
   * @memberof HelpPageComponent
   */
  static displayName = `HelpPage`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof HelpPageComponent
   */
  static propTypes = HelpPagePropTypes;

  /**
   * Data specific to the `<HelpPage />` instance
   * @type {HelpPageComponentState}
   * @memberof HelpPageComponent
   */
  state = {};

  /**
   * Render the component
   * @returns {React.Component} The rendered `<HelpPage />`
   * @memberof HelpPageComponent
   */
  render() {
    const { classes, entry } = this.props;
    return (
      <Page heading="HelpPage.PageHeading" headingData={{ name: entry.name }} hideSidebar padding="normal" title="HelpPage.PageTab">
        <div className={classes.root}>
          <Grid classes={{ container: classes.titleHeader }} container justify="space-between">
            <Grid item xs={6}>
              <I18n className={classes.title} data={{ name: entry.name }} variant="h6">
                HelpPage.PageTitle
              </I18n>
            </Grid>
            <Grid item xs>
              <I18n align="right" className={classes.redirectTitle} component={Link} to={createLoginPageLink()} variant="body2">
                HelpPage.Redirect
              </I18n>
            </Grid>
            <Grid item lg={8} xl={6} xs={12}>
              <Paper className={classes.container} elevation={0}>
                <I18n data={{ name: entry.name }} inline paragraph variant="body2">
                  HelpPage.SignInHelp
                </I18n>
                <I18n data={{ name: entry.name }} inline variant="body2">
                  HelpPage.SignInHelpParagraph
                </I18n>
              </Paper>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <I18n className={classes.title} data={{ name: entry.name }} variant="h6">
                HelpPage.ForgotPasswordTitle
              </I18n>
            </Grid>
            <Grid item lg={8} xl={6} xs={12}>
              <Paper className={classes.container} elevation={0}>
                <ListItemText>
                  <I18n data={{ name: entry.name }} variant="body2">
                    HelpPage.ForgotUsername
                  </I18n>
                  <I18n data={{ name: entry.name }} variant="body2">
                    HelpPage.ForgotUsername2
                  </I18n>
                  <I18n data={{ name: entry.name }} variant="body2">
                    HelpPage.ForgotUsername3
                  </I18n>
                  <I18n data={{ name: entry.name }} variant="body2">
                    HelpPage.ForgotUsername4
                  </I18n>
                </ListItemText>
              </Paper>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <I18n className={classes.title} data={{ name: entry.name }} variant="h6">
                HelpPage.SignIn
              </I18n>
            </Grid>
            <Grid item lg={8} xl={6} xs={12}>
              <Paper className={classes.container} elevation={0}>
                <List>
                  <ListItemText>
                    <I18n data={{ name: entry.name }} variant="body2">
                      HelpPage.SignInList1
                    </I18n>
                  </ListItemText>
                  <ListItemText>
                    <I18n component={Link} data={{ name: entry.name }} target="_self" to="//portal.boralconnects.com.au" variant="body1">
                      HelpPage.SignInList1a
                    </I18n>
                  </ListItemText>
                  <I18n data={{ name: entry.name }} variant="body2">
                    HelpPage.SignInList2
                  </I18n>
                  <I18n data={{ name: entry.name }} variant="body2">
                    HelpPage.SignInList3
                  </I18n>
                </List>
              </Paper>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <I18n className={classes.title} data={{ name: entry.name }} variant="h6">
                HelpPage.Report
              </I18n>
            </Grid>
            <Grid item lg={8} xl={6} xs={12}>
              <Paper className={classes.container} elevation={0}>
                <I18n data={{ name: entry.name }} variant="body2">
                  HelpPage.SecurityIssue
                </I18n>
                <I18n data={{ name: entry.name }} variant="body2">
                  HelpPage.SecurityIssue2
                </I18n>
                <I18n data={{ name: entry.name }} variant="body2">
                  HelpPage.SecurityIssue3
                </I18n>
                <I18n data={{ name: entry.name }} variant="body2">
                  HelpPage.SecurityIssue4
                </I18n>
                <br />
                <I18n data={{ name: entry.name }} variant="caption">
                  HelpPage.SecurityIssue5
                </I18n>
              </Paper>
            </Grid>
          </Grid>
          <Grid className={classes.foot} item sm={6} xs={12}>
            <Footer />
          </Grid>
        </div>
      </Page>
    );
  }
}

/** @type {React.ComponentClass<HelpPageComponentProps>} */
const HelpPage = compose(
  withEntries,
  withStyles(themeCreateInjectableStyles(helpPageStyles), { withTheme: true }),
)(HelpPageComponent);

export default HelpPage;
